module.exports = __webpack_public_path__ + "static/img/image_poster.a075663.png";